import React from "react";
import ReactECharts from "echarts-for-react";

const ChatPerMonth = ({chatPerMonth = []}) => {
    const dataMonth = chatPerMonth.map(item => item.Values);
    const option = {
        tooltip: { trigger: "axis" },
        xAxis: {
            type: "category",
            data: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
        },
        yAxis: { type: "value" },
        series: [
            {
                name: "Chats",
                type: "line",
                smooth: true,
                data: dataMonth,
                areaStyle: { color: "rgba(47,90,162,0.2)" },
                lineStyle: { color: "#2f5aa2" },
                itemStyle: { color: "#2f5aa2" }
            }
        ]
    };

    return (
        <div className="card" style={{ height: "450px" }}>
            <div className="card-body">
                <div>
                    <h5>Chat Per Month</h5>
                    <p className="fs-9 fw-semibold mb-0">Users across countries</p>
                </div>
                <ReactECharts className="w-100" option={option} style={{ height: 400 }} />
            </div>
        </div>
    );
};

export default ChatPerMonth;
